module.exports = __webpack_public_path__ + "static/img/manual_ja_26.58fe1ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_26.png
// module id = 0Asq
// module chunks = 4